import { httpClient } from '@/core/http';
import { ChatService } from './chat.service';

export const chatService = new ChatService(httpClient);
export * from './chat.model';
